import { render, staticRenderFns } from "./variationTest.vue?vue&type=template&id=5d3f0e8a&scoped=true"
import script from "./variationTest.vue?vue&type=script&lang=js"
export * from "./variationTest.vue?vue&type=script&lang=js"
import style0 from "./variationTest.vue?vue&type=style&index=0&id=5d3f0e8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3f0e8a",
  null
  
)

export default component.exports